import { Alert, Button, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ExpiredMembershipBanners from "../membership/ExpiredMembershipBanners";
import { ClubAccess } from "./useClubAccess";

function ClubAccessBanners({
  access,
  clubId,
  clubName,
  devPort,
  userName,
  setSubscriptionMode,
}: {
  access: ClubAccess;
  clubId: number;
  clubName: string;
  devPort: string;
  userName: string;
  setSubscriptionMode?: (mode: string) => void;
}) {
  const navigate = useNavigate();

  function goToSubscription(mode: "create" | "modify") {
    setSubscriptionMode?.(mode);
    navigate("/managersubscription");
  }

  function updatePaymentMethod() {
    fetch(devPort + "create-billing-portal-session", {
      method: "post",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ clubId: clubId, website: window.location.href.split("#")[0] }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data && data.url) {
          window.location.href = data.url;
        }
      });
  }

  if (access.loading) {
    return null;
  }

  return (
    <Stack spacing={2}>
      {access.needsSubscription && (
        <Alert
          severity="info"
          data-testid="subscribe-club-banner"
          action={
            <Button
              color="inherit"
              size="small"
              data-testid="subscribe-club"
              onClick={() => goToSubscription("create")}
            >
              Subscribe
            </Button>
          }
        >
          {clubName} doesn't have a Chukkerbook subscription yet. Subscribe to start
          scheduling events.
        </Alert>
      )}
      {access.invalidCard && (
        <Alert
          severity="error"
          action={
            <Button
              color="inherit"
              size="small"
              data-testid="update-payment-method"
              onClick={updatePaymentMethod}
            >
              Update card
            </Button>
          }
        >
          Your credit card for {clubName} expired. Enter a new form of payment to keep
          using Chukkerbook.
        </Alert>
      )}
      {access.overPlayerLimit && (
        <Alert
          severity="warning"
          action={
            <Stack direction="row" spacing={1}>
              <Button
                color="inherit"
                size="small"
                data-testid="manager-players"
                onClick={() => navigate("/player")}
              >
                Manage players
              </Button>
              <Button
                color="inherit"
                size="small"
                data-testid="membership-upgrade"
                onClick={() => goToSubscription("modify")}
              >
                Upgrade
              </Button>
            </Stack>
          }
        >
          {clubName} has reached the maximum number of players for its plan.
        </Alert>
      )}
      <ExpiredMembershipBanners
        devPort={devPort}
        clubId={String(clubId)}
        expiredSubscription={access.expired}
        subscriptionEndDate={access.subscriptionEndDate}
        setSubscriptionEndDate={(value) =>
          access.setSubscriptionEndDate(
            typeof value === "function" ? value(access.subscriptionEndDate) : value
          )
        }
        userName={userName}
      />
    </Stack>
  );
}

export default ClubAccessBanners;
